import { render, staticRenderFns } from "./ConstantActiveIngredientDetails.vue?vue&type=template&id=24167620&scoped=true&"
import script from "./ConstantActiveIngredientDetails.vue?vue&type=script&lang=js&"
export * from "./ConstantActiveIngredientDetails.vue?vue&type=script&lang=js&"
import style0 from "./ConstantActiveIngredientDetails.vue?vue&type=style&index=0&id=24167620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24167620",
  null
  
)

export default component.exports